import { Typography, useTheme } from "@mui/material";
import { useMemo } from "react";
import { getMaxSessionParticipants } from "@components/Pages/Events/eventFunctions";

const EventTotalParticipants = ({ event }) => {
  const theme = useTheme();

  const uniqueParticipants = useMemo(() => {
    if (!event) {
      return '';
    }
    return getMaxSessionParticipants(event);
  }, [event]);

  return (
    <Typography
      variant="body1"
      sx={{ fontFamily: "Montserrat", marginTop: "38px", marginBottom: "24px" }}
      gutterBottom
    >
      <span style={{ fontWeight: 600, fontSize: theme.typography.pxToRem(22) }}>
        Total Participants for this event: {uniqueParticipants || "-"}
      </span>
    </Typography>
  );
}

export default EventTotalParticipants;
